import advertising from './advertising';
import locations from './locations';
import metadata from './metadata';
import news from './news';
import ratings from './ratings';
import sitesettings from './sitesettings';
import user from './user';

export const reducers = {
  sitesettings,
  metadata,
  user,
  locations,
  ratings,
  news,
  advertising,
};
